// utils/sports.js
export const SPORTS = [
  { key: "archery", label: "Archery"},
  { key: "badminton", label: "Badminton"},
  { key: "baseball", label: "Baseball" },
  { key: "basketball", label: "Basketball" },
  { key: "billards", label: "Billards"},
  { key: "bocce", label: "Bocce"},
  { key: "bowling", label: "Bowling"},
  { key: "darts", label: "Darts"},
  { key: "dodgeball", label: "Dodgeball"},
  { key: "flag_football", label: "Flag Football" },
  { key: "football", label: "Football"},
  { key: "futsal", label: "Futsal" },
  { key: "kickball", label: "Kickball"},
  { key: "lacrosse", label: "Lacrosse" },
  { key: "pickleball", label: "Pickleball" },
  { key: "soccer", label: "Soccer" },
  { key: "softball", label: "Softball" },
  { key: "table_tennis", label: "Table Tennis"},
  { key: "tennis", label: "Tennis" },
  { key: "volleyball", label: "Volleyball" },
];
